import { iWaHolidayNotificationWorkflow } from "@sdk/wa-holiday-notification-workflows/wa-holiday-notification-workflows-models";
import { CreateEntitySlice } from "../../utils/entity-slice-creator";
import { waHolidayNotificationWorkflowsDefaultQueryConfig } from "./wa-holiday-notification-workflows-default-query";

export const {
  slice: WAHolidayNotificationWorkflowsSlice,
  reducers: WAHolidayNotificationWorkflowsSliceReducer,
  actions: {
    setEntityQueryResults: setWAHolidayNotificationWorkflowsQueryResults,
    setEntity: setWAHolidayNotificationWorkflow,
    setEntities: setWAHolidayNotificationWorkflows,
    patchEntity: patchWAHolidayNotificationWorkflow,
    addNewEntity: addNewWAHolidayNotificationWorkflow,
    setEntityFetchingStatus: setWAHolidayNotificationWorkflowFetchingStatus,
    setEntitiesFetchingStatus: setWAHolidayNotificationWorkflowsFetchingStatus,
    setEntityFailedStatus: setWAHolidayNotificationWorkflowFailedStatus,
    setEntityQueryError: setWAHolidayNotificationWorkflowsQueryError,
    resetQuery: resetWAHolidayNotificationWorkflowsQuery,
    setQueryList: setWAHolidayNotificationWorkflowQueryList,
  },
} = CreateEntitySlice<iWaHolidayNotificationWorkflow>({
  sliceName: "waHolidayNotificationWorkflows",
  queryAliasResolver: (queryAlias: string) => {
    if (queryAlias === "all") {
      return {
        ...waHolidayNotificationWorkflowsDefaultQueryConfig,
        alias: "all",
      };
    }
  },
});
